import { FileArchive, Workflow } from "lucide-react";
import type { ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";
import type { ShowStory } from "../show-generator";
import { storyTitle } from "../show-generator";

export function ShowStoryHeader({ story, actions }: { story: ShowStory; actions?: ReactNode }) {
  const root = `/show-generator/stories/${story.id}`;
  const location = useLocation();
  const artifactsActive = location.pathname === root || location.pathname === `${root}/artifacts`;
  return <section className="story-context">
    <h1>{storyTitle(story)}</h1>
    <div className="story-context-actions">
      <nav aria-label="Story views">
        <NavLink to={root} end className={({ isActive }) => artifactsActive || isActive ? "active" : undefined}><FileArchive size={15} />Artifacts</NavLink>
        <NavLink to={`${root}/operations`} className={({ isActive }) => isActive ? "active" : undefined}><Workflow size={15} />Operations</NavLink>
      </nav>
      {actions ? <><span className="story-action-divider" aria-hidden="true" /><div className="story-header-commands">{actions}</div></> : null}
    </div>
  </section>;
}
